import { useTheme, useMediaQuery } from '@mui/material';

/**
 * True when viewport is below the `md` breakpoint (900px).
 * Matches MainDrawer mobile shell and mobile-responsive-design.md.
 */
export default function useIsMobile() {
  const theme = useTheme();
  return useMediaQuery(theme.breakpoints.down('md'));
}
